/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useRef, useState } from 'react';
import {
  TextField,
  FormControl,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useForm } from 'react-hook-form';
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import {Download04Icon, Cancel01Icon } from '@hugeicons-pro/core-stroke-standard';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { exportBillingReport } from 'src/services/reportService';
import CsvService from 'src/services/dataExport.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useLocation } from 'react-router-dom';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';
import type { RootState } from '../../store/store';
import { useSelector } from 'react-redux';

interface FormValues {
  startDate: string;
  endDate: string;
}

interface BillingReportData {
  campaignID: string;
  campaignName: string;
  campaignType:string;
  campaignCreatedDate: string;
  campaignStartDate: string;
  campaignEndDate: string;
  firstEmailCreatedDate: string;
  lastEmailCreatedDate: string;
  sentCount: string;
}

const BillingReport: React.FC = (): JSX.Element => {
  const location = useLocation();
  const state = location.state as { start?: Date; end?: Date } | null;
  const today = new Date();
  
  // Calculate default start date as 1 month before today
  const defaultStart = new Date();
  defaultStart.setMonth(today.getMonth() - 1);
  
  // Use location state dates if provided, otherwise use defaults
  const { start = defaultStart, end = today } = state ?? {};
  
  const [isDataLoading, setIsDataLoading] = useState(false);
  const dateRangeRef: any = useRef(null);
  const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
  const [fromDate, setFromDate] = useState<any>(start)
  const [endDate, setEndDate] = useState<any>(end)
  const [reportDateRange, setReportDateRange] = useState<any>()
  const [reportData, setReportData] = useState<any>([])
  const [totalSentCount, setTotalSentCount] = useState<number>(0);
  const { user} = useSelector((state: RootState) => state.auth);
 
  const validationSchema = Yup.object().shape({  
    startDate: Yup.string().required("Report start date required")
      .test("valid-date", "Invalid date format", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      ),
    endDate: Yup.string().required("Report end date required")
      .test("valid-date", "Invalid date format", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      )
      .test("endAfterStart", "End date must be after start date", function (value) {
        const { startDate } = this.parent;
        return moment(value, "YYYY-MM-DD").isSameOrAfter(moment(startDate, "YYYY-MM-DD"));
      })
  });

  const {
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      startDate: moment(start).format('YYYY-MM-DD'),
      endDate: moment(end).format('YYYY-MM-DD'), 
    },
    mode: 'onChange' // This will validate on every change
  });
  useEffect(() => {
       void onFormSubmit();
    }, [user]);


const handleClearDateRange = (): void => {
  const today = new Date();
  const defaultStart = new Date();
  defaultStart.setMonth(today.getMonth() - 1);

  reset({
    startDate: moment(defaultStart).format('YYYY-MM-DD'),
    endDate: moment(today).format('YYYY-MM-DD'),
  });

  setFromDate(defaultStart);
  setEndDate(today);
  setReportDateRange({
    startDate: defaultStart,
    endDate: today,
    key: 'selection',
  });

}

  const onSubmit = async (customStartDate?: Date, customEndDate?: Date): Promise<void> => { 
  
    // Validate the form before submission
    const isFormValid = await trigger();
    if (!isFormValid) {
      console.log('Form validation failed');
      return;
    }

    // ✅ FIX: Correctly get clientId from userData and ensure it's a number
    const clientId = Number(user?.clientId ?? 0);
     const startDateToUse = customStartDate ?? fromDate;
  const endDateToUse = customEndDate ?? endDate;
  
  const formattedStartDate = moment(startDateToUse).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDateToUse).format('YYYY-MM-DD');
  

    setIsDataLoading(true);
    exportBillingReport(clientId, formattedStartDate, formattedEndDate)
      .then((res: any) => {
        setIsDataLoading(false);
        if (res.status === 200) {
          if (res.data.result === 1) {
            const reportData = res.data.data.campaignReport; 
            const total = res.data.data.total;                      
            if (reportData.length > 0) {
              setReportData(reportData);    
              setTotalSentCount(total);                        
            } else {
              setReportData([]);
              setTotalSentCount(0);
              NotificationManager.error('No data available for download', '', 5000);
            }
          } else {
            setReportData([]);
            setTotalSentCount(0);
            NotificationManager.error('No data available for download', '', 5000);
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching billing report:', error);
        NotificationManager.error('Unknown error has occurred', '', 5000);
      })
      .finally(() => {
        setIsDataLoading(false);
      });
  }
const onFormSubmit = async (): Promise<void> => {
  await onSubmit();
}
  const formatExportDate = (date: string | null | undefined): string =>
    (date != null) ? moment(date).format("MM-DD-YYYY HH:mm:ss") : "N/A";

  const handleExportReport = (): void => {
    const data: any = [];
    if (reportData.length > 0) {
      reportData.map((item: any) => {
        const newItem = {
          "Campaign Name": item.campaignName,
          "Campaign ID": item.campaignID,     
          "Campaign Type":item.campaignType,
          "Campaign Created Date": formatExportDate(item.campaignCreatedDate),
          "Campaign Date Started": formatExportDate(item.campaignStartDate),
          "Campaign End Date": formatExportDate(item.campaignEndDate),
          "First Email Created Date": formatExportDate(item.firstEmailCreatedDate),
          "Last Email Created Date": formatExportDate(item.lastEmailCreatedDate),
          "Sent Count": item.sentCount                        
        }
        data.push(newItem)
      })
      data.push({
        "Campaign Name": 'Total',
        "Campaign ID": '',     
        "Campaign Type":'',
        "Campaign Created Date": '',
        "Campaign Date Started": '',
        "Campaign End Date": '',
        "First Email Created Date": '',
        "Last Email Created Date": '',
        "Sent Count": totalSentCount
      });
      const clientName: string = user?.selectedClientName ? user.selectedClientName.replaceAll(' ', '_') : 'Client';
      CsvService.downloadXlsFile(data, `${clientName}_CE_Billing_Report.xlsx`);
    } else {
      NotificationManager.error('No data available for download', '', 5000);
    }
  }
    
const handleDateRangeClick = (ranges: any): void => {
  const selectedStart = moment(ranges.selection.startDate).startOf('day').toDate();
  const selectedEnd = moment(ranges.selection.endDate).endOf('day').toDate();

  // Detect if user is selecting only one date (same start & end)
  const isSingleSelection = moment(selectedStart).isSame(selectedEnd, 'day');

  if (isSingleSelection) {
    // ✅ Fix for 'Today' and 'Yesterday' — set both start and end to same day
    setFromDate(selectedStart);
    setEndDate(selectedStart);
    setReportDateRange({
      startDate: selectedStart,
      endDate: selectedStart,
      key: 'selection'
    });
    setValue('startDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
    setValue('endDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
  } else {
    // Normal multi-date selection
    setFromDate(selectedStart);
    setEndDate(selectedEnd);
    setReportDateRange({
      startDate: selectedStart,
      endDate: selectedEnd,
      key: 'selection'
    });
    setValue('startDate', moment(selectedStart).format('YYYY-MM-DD'), { shouldValidate: true });
    setValue('endDate', moment(selectedEnd).format('YYYY-MM-DD'), { shouldValidate: true });
  }
};



  const handleDateChange = (): void => {
    setIsDateRangeOpen(true)
    setReportDateRange({
      startDate: fromDate,
      endDate: endDate,
      key: 'selection'
    })
  }

  // Initialize date range on component mount
  useEffect(() => {
    setReportDateRange({
      startDate: fromDate,
      endDate: endDate,
      key: 'selection'
    });
  }, [fromDate, endDate]);

  const formatDate = (date?: string | null): string => {
    return (date != null) ? moment(date).format("MM/DD/YYYY") : "N/A";
  };
useEffect(() => {
  const handleClickOutside = (event: MouseEvent): void => {
    if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
      setIsDateRangeOpen(false);

      // Keep whatever date range was last selected
      setFromDate(reportDateRange?.startDate);
      setEndDate(reportDateRange?.endDate);

      setValue('startDate', moment(reportDateRange?.startDate).format('YYYY-MM-DD'));
      setValue('endDate', moment(reportDateRange?.endDate).format('YYYY-MM-DD'));
    }
  };

  if (isDateRangeOpen) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [isDateRangeOpen, reportDateRange, setValue]);
  const columns: TableColumn<BillingReportData>[] = [
    {
      name: 'Campaign ID',
      selector: (row: BillingReportData) => row.campaignID ?? 0,
      width: '10%',
      wrap: true,
      sortable: true
    },
    {
      name: 'Campaign Name',
      selector: (row: BillingReportData) => row.campaignName,
      width: '13%',
      wrap: true,
      sortable: true,
      cell: (row: BillingReportData) => (
        <div 
          title={row.campaignName}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%'
          }}
        >
          {row.campaignName}
        </div>
      )
    },
    {
      name: 'Campaign Type',
      selector: (row: BillingReportData) => row.campaignType,
      width: '10%',
      wrap: true,
      sortable: true,
      cell: (row: BillingReportData) => (
        <div 
          title={row.campaignType}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%'
          }}
        >
          {row.campaignType}
        </div>
      )
    },
    {
      name: 'Campaign Created Date',
      selector: (row: BillingReportData) => formatDate(row.campaignCreatedDate),
      width: '12%',
      wrap: true,
      cell: (row: BillingReportData) => (
        <div title={formatDate(row.campaignCreatedDate)}>
          {formatDate(row.campaignCreatedDate)}
        </div>
      )
    },
    {
      name: 'Campaign Start Date',
      selector: (row: BillingReportData) => formatDate(row.campaignStartDate),
      width: '12%',
      wrap: true,
      cell: (row: BillingReportData) => (
        <div title={formatDate(row.campaignStartDate)}>
          {formatDate(row.campaignStartDate)}
        </div>
      )
    },
    {
      name: 'Campaign End Date',
      selector: (row: BillingReportData) => formatDate(row.campaignEndDate),
      width: '12%',
      wrap: true,
      cell: (row: BillingReportData) => (
        <div title={formatDate(row.campaignEndDate)}>
          {formatDate(row.campaignEndDate)}
        </div>
      )
    },
    {
      name: 'First Email Created Date',
      selector: (row: BillingReportData) => formatDate(row.firstEmailCreatedDate),
      width: '12%',
      wrap: true,
      cell: (row: BillingReportData) => (
        <div title={formatDate(row.firstEmailCreatedDate)}>
          {formatDate(row.firstEmailCreatedDate)}
        </div>
      )
    },
    {
      name: 'Last Email Created Date',
      selector: (row: BillingReportData) => formatDate(row.lastEmailCreatedDate),
      width: '12%',
      wrap: true,
      cell: (row: BillingReportData) => (
        <div title={formatDate(row.lastEmailCreatedDate)} >
          {formatDate(row.lastEmailCreatedDate)}
        </div>
      )
    },
    {
      name: 'Sent Count',
      selector: (row: BillingReportData) => row.sentCount ?? 0,
      width: '8%',
      wrap: true,
      center: true, 
      cell: (row: BillingReportData) => (
        <div className="w-full h-full flex justify-center items-center">
          <p className="text-14 text-muted">{row.sentCount ?? 0}</p>
        </div>
      )
    }
  ];

  return (
    
        <>
          <h2 className="text-2xl font-semibold text-title">Billing Reports</h2>
          <div className="mt-[20px] mb-[20px] live-outreach-container">
            <form onSubmit={handleSubmit(onFormSubmit)}  className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-5">
              {/* Date Range Field */}
              <div className="w-full lg:w-auto">
                <FormControl>
                  <TextField
                    id="date-range"
                    label="Date Range*"
                    variant="outlined"
                    autoComplete='off'
                    ref={dateRangeRef}
                    InputProps={{
                      endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                        <IconButton
                          onClick={handleClearDateRange}
                          size="small"
                          sx={{ marginRight: '4px' }}
                        >
                          <HugeiconsIcon
                            icon={Cancel01Icon}
                            size={16}
                            color="#666"
                            strokeWidth={0.5}
                          />
                        </IconButton>
                        <HugeiconsIcon
                          icon={Calendar03Icon}
                          size={18}
                          color="#3A3A3A"
                          strokeWidth={0.5}
                          onClick={handleDateChange}
                        />
                      </InputAdornment>
                    }}
                    onChange={handleDateChange}
                    onFocus={handleDateChange}
                    value={`${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`}
                    sx={{
                      width: { xs: '100%', sm: '230px', md: '230px', lg: '230px' },
                      minWidth: '200px',
                      '& .MuiOutlinedInput-root': {
                        height: '56px',
                        '& .MuiOutlinedInput-input': {
                          padding: '16px 14px',
                          height: 'auto',
                          lineHeight: '1.4375em',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        padding: '0 4px',
                        fontSize: '13px',
                        left: '16px',
                        lineHeight: '1.2',
                      },
                    }}
                  />
                  {(errors.startDate ?? errors.endDate) && (
                    <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', marginLeft: '14px', lineHeight: '1.2' }}>
                      {errors.startDate?.message ?? errors.endDate?.message ?? ''}
                    </div>
                  )}
                  {isDateRangeOpen && (
                    <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999', top: '100%', marginTop: '4px' }}>
                      <DateRangePicker
                        ranges={[reportDateRange]} 
                        onChange={handleDateRangeClick}
                        dateDisplayFormat={'MM/dd/yyyy'}
                        inputRanges={[]}
                        color={"#FFF5F6"}
                        rangeColors={["#D6242C"]}
                        editableDateInputs={true}
                        startDatePlaceholder={"MM/DD/YYYY"}
                        endDatePlaceholder={"MM/DD/YYYY"}
                      />
                    </div>
                  )}
                </FormControl>
              </div>

              {/* Buttons Section */}
              <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-2 w-full lg:mt-2">
                {/* <div className="w-full sm:w-auto">
                  <OutlineButton 
                    color="gray" 
                    onClick={handleReset} 
                    disabled={isDataLoading}
                    width="150px" 
                  >
                    Reset
                  </OutlineButton>
                </div> */}
                
                <div className="w-full sm:w-auto">
                  <GradientButton
                    type="submit"
                    color="red"
                    disabled={isDataLoading}
                    width="150px" 
                    onClick={() => void handleSubmit(onFormSubmit)()}
                  >
                    {!isDataLoading ? 'Submit' : (
                      <span className="loading loading-spinner loading-xs text-white"></span>
                    )}
                  </GradientButton>
                </div>
                {reportData.length > 0 && 
                  <div className="w-full sm:w-auto">
                    <OutlineButton 
                      onClick={handleExportReport} 
                      type="rounded" 
                      color="gray" 
                      width="150px"
                    >
                      <HugeiconsIcon
                        icon={Download04Icon}
                        size={20}
                        color="#3a3a3a"
                        stroke="0.2"
                      />
                      <span className="ml-[5px]">Download</span>
                    </OutlineButton>
                  </div>
                }
              </div>
            </form>
          </div>
          <div className='data-table-container te-table-container mb-10'>
            <CustomDataTable
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              columns={columns}
              data={reportData}
              pagination
              //   selectableRows
              progressPending={isDataLoading}
            />
          </div>
        </>
);
};

export default BillingReport;